import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import HTMLReactParser from 'html-react-parser';

import LeaveButton from '../../../components/LeaveButton';
import { VaccineIcon } from '../../../assets/icons';
import { UserVaccination } from '../../../services/models';

interface Props {
  vaccination: UserVaccination;
}

const AccreditedNetwork = ({ vaccination }: Props) => {
  const { locationDescription, locationComplement } = vaccination;
  const classes = useStyles();
  console.log(vaccination);
  return (
    <Grid container className={classes.container}>
      <Grid item>
        <Box px={2} className={classes.disclaimer}>
          <img src={VaccineIcon} alt="vaccine-icon" />
          <Typography variant="h2">
            Sua vacina está disponível na rede credenciada.
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Container maxWidth="sm" className={classes.content}>
          {/* <Typography variant="h3">{vaccinationPoint?.description}</Typography>
          <Typography>{vaccinationPoint?.address}</Typography>
          <Typography>{vaccinationPoint?.neighborhood}</Typography>
        <Typography>{vaccinationPoint?.city} / {vaccinationPoint?.state}</Typography> */}
          <Typography>
            {locationDescription && HTMLReactParser(locationDescription)}
          </Typography>
        </Container>
      </Grid>
      <Grid item>
        <Container maxWidth="md" className={classes.infoContainer}>
          <Box marginY={4}>
            <Typography>{locationComplement}</Typography>
          </Box>
          <Typography>
            No caso de dúvidas, entre em contato com o <strong>ENLACE</strong>{' '}
            através do telefone <strong>0800 709 2364</strong> para consultar
            disponibilidade da vacina contra gripe.
          </Typography>
        </Container>
      </Grid>
      <LeaveButton className={classes.leaveButton} />
    </Grid>
  );
};

export default AccreditedNetwork;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      paddingBottom: theme.spacing(4),
      flexDirection: 'column',
      [theme.breakpoints.only('xs')]: {
        minHeight: '80vh',
      },
    },

    disclaimer: {
      textAlign: 'center',
      '& h2': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 'bold',
      },
    },

    content: {
      margin: theme.spacing(4, 'auto'),
      padding: theme.spacing(2.75),
      borderRadius: 20,
      boxShadow: theme.shadows[2],

      '& > h3': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 'bold',
      },
    },

    leaveButton: {
      bottom: 10,
    },

    infoContainer: {
      padding: theme.spacing('auto', 3),
      textAlign: 'center',
    },
  })
);
